module.exports = __webpack_public_path__ + "img/merchants-text.ff0eb153.png";